module.exports = __webpack_public_path__ + "static/media/image5.36599f43.jpg";